import React from 'react'
import SessionTimer from 'Pages/Home/Components/SessionTimer'
import { set, get } from "@Core/LocalStorage";

const Header = (props) => {
  let {handleLogout} = props;
  const srmwuiCustomerObj = get('srmwuiCustomerObj') || {}
  const userToken = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userToken : '';

  return (
    <nav className="navbar navbar-expand-md navbar-light fixed-top nav-light">
      <div className="container-fluid d-flex justify-content-between">
        <a className="navbar-brand" href="#">
          <img className="img-fluid" src="./img/logo.svg" alt="logo" />
        </a>
        {userToken && <SessionTimer handleLogout={handleLogout}/>}
      </div>
    </nav>
  )
}

export default Header
